<template>
  <v-card class="mb-7">
    <v-card-text class="pa-5">
      <div class="d-sm-flex align-center">
        <div class="ml-3">
          <h2 class="font-weight-regular title">Matrículas</h2>
          <h6 class="body-2 mb-1 subtitle-2 font-weight-light">Datos de matrículas</h6>
        </div>
      </div>
    <!-- Header -->
    <div class="d-flex align-center pa-3">
      <v-select
        v-model="filters.tipoPago"
        label="Tipo de pago"
        class="mr-5"
        :items="matriculaPaymentTypes"
        item-text="text"
        item-value="value"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        @change="filters.page = 1"
      />

      <v-select
        v-model="filters.seccion"
        label="Sección"
        class="mr-5"
        :items="secciones"
        item-text="nombre"
        item-value="id"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        clearable
        @change="filters.page = 1"
      />

      <v-select
          v-model="filters.estadoPago"
          label="Estado pago"
          class="mr-5"
          :items="estadoPagoItems"
          item-text="text"
          item-value="value"
          outlined
          dense
          style="max-width: 210px;"
          hide-details
          clearable
          @change="filters.page = 1"
      />
      <v-select
        v-model="filters.beneficio"
        label="Beneficio"
        class="mr-5"
        :items="beneficioItems"
        item-text="text"
        item-value="value"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        clearable
        @change="filters.page = 1"
      />
      <BaseDataRange
        style="max-width: 474px; margin: 0;"
        @sendStartDate="sendStartDate"
        @sendEndDate="sendEndDate"
        @clearStartDate="filters.startDate=''"
        @clearEndDate="filters.endDate=''"
      />
    </div>
    <!-- Fin header -->

    <div class="pa-3 pt-0" style="max-width: 420px;">
      <v-text-field
        v-model="searchLocal"
        prepend-inner-icon="mdi-magnify"
        dense
        outlined
        clearable
        hide-details
        label="Buscar coincidencias"
        @input="onLocalSearchInput"
      />
    </div>



    <!-- Table -->
      <v-data-table
        :headers="headerArray"
        :items="matriculas"
        :page.sync="filters.page"
        :items-per-page="pageSize"
        :server-items-length="totalPages"
        :loading="loading"
        hide-default-footer
      >
        <template v-slot:item.nombre="{ item }">
          <div class="d-flex" style="cursor: pointer;">
            <div class="my-auto">
              <h4 class="font-weight-medium text-no-wrap">
                {{ item.usuario.display_name }}
              </h4>
              <h6 class="font-weight-medium text-no-wrap">
                {{ item.usuario.email }}
              </h6>
              <p class="font-weight-medium text-no-wrap ma-0  enrollment_date" v-if="item.fecha_matricula !== null">
                Matriculado el {{ item.fecha_matricula | moment("DD/MM/YYYY [a las]  HH:mm")}}
              </p>
            </div>
          </div>
        </template>

        <template v-slot:item.seccion="{ item }">
          <div class="d-flex" style="cursor: pointer;">
            <div class="my-auto">
              <p class="mb-0">
                {{ item.seccion.nombre }}
              </p>
              <h6 class="font-weight-medium text-no-wrap">
                {{ item.seccion.fecha_inicio | moment("DD/MM/YYYY") }} ~ {{ item.seccion.fecha_fin | moment("DD/MM/YYYY")}}
              </h6>
            </div>
          </div>
        </template>

        <template v-slot:item.apps_activas="{ item }">
          <div class="d-flex justify-center" style="cursor: pointer;">
            <template v-if="item.usuario.apps_activas.length">
              <div
                v-for="(app, index) in item.usuario.apps_activas"
                :key="index"
                dense
                class="app-chip mx-1"
              >
                {{ app }}
              </div>
            </template>
            <p v-else class="mb-0">-</p>
          </div>
        </template>

        <template v-slot:item.pago_cuotas="{ item }">
          <div class="d-flex justify-center">
            <span>{{ item.pago_cuotas ? 'En cuotas' : 'Contado' }}</span>
          </div>
        </template>
        <template v-slot:item.estado_pago="{ item }">
          <div class="d-flex justify-center">
            <v-chip
              small
              label
              :color="isPagado(item) ? 'primary' : 'error'"
              dark
              class="font-weight-bold"
            >
              <v-icon left small>
                {{ isPagado(item) ? 'mdi-check-circle' : 'mdi-alert-circle' }}
              </v-icon>
              <span v-if="isPagado(item)">Pagado</span>
              <span v-else>{{ pendiente(item) }}</span>
            </v-chip>
          </div>
        </template>

        <template v-slot:item.acciones="{ item }">
          <div class="d-flex flex-column align-center py-2">
            <v-btn v-if="item.pago_cuotas" class="actions-btn actions-btn--success mb-1" x-small @click="setMatricula(item)">Enviar alerta</v-btn>
            <v-btn class="actions-btn mb-1" x-small color="primary" @click="setPremiumUser(item.usuario)">Dar membresía</v-btn>
            <v-btn class="actions-btn actions-btn--secondary" x-small @click="removePremium(item.usuario.id, item.usuario.apps_activas)">Quitar membresía</v-btn>
          </div>
        </template>

        <!-- customizing pagination -->
        <template v-slot:footer="slotProps">
            <div class="pagination d-flex ml-auto mr-0 mt-5">
                <v-btn icon @click="filters.page > 1 ? filters.page--: ''" :disabled="filters.page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <p class="ma-auto">{{ slotProps.props.pagination.page }} de {{ totalPages }}</p>
                <v-btn icon @click="filters.page < totalPages ? filters.page++: ''" :disabled="next === null"><v-icon>mdi-chevron-right</v-icon></v-btn>
            </div>
          </template>
        <!-- customizing pagination -->
      </v-data-table>
    <!-- Table -->
    </v-card-text>

    <make-premium-modal 
      v-model="showMakePremiumModal" 
      :user="userSelected"
      @close="showMakePremiumModal = false"
      @updated="showMakePremiumModal = false; fetchMatriculas()"
    ></make-premium-modal>

    <payment-alert-modal
      v-model="showPaymentAlertModal"
      :matricula="matriculaSelected"
      @close="showPaymentAlertModal = false"
      @updated="showPaymentAlertModal = false"
    >
    </payment-alert-modal>
  </v-card>
</template>

<script>
// import NProgress from "nprogress"
import { mapMutations, mapState } from 'vuex'
import BaseDataRange from '@/components/commonComponents/BaseDataRange'
import MakePremiumModal from '@/components/dashboardComponents/matriculas/MakePremiumModal'
import PaymentAlertModal from '@/components/dashboardComponents/matriculas/PaymentAlertModal'

export default {
  name: "TheMatriculasTable",
  components: {
    BaseDataRange,
    MakePremiumModal,
    PaymentAlertModal
  },
  data: () => ({
    pageCount: 0,
    loading: false,
    matriculas: [],
    pageSize: 15,
    totalPages: 1,
    next: null,
    searchLocal: '',
    secciones: [],
    headerArray: [
      { text: 'Nombre', value: 'nombre', sortable: false, align: 'start' },
      { text: 'Seccion', value: 'seccion', sortable: false, align: 'start' },
      { text: 'Monto pagado', value: 'monto_pagado', sortable: false, align: 'center' },
      { text: 'Monto total', value: 'monto_total', sortable: false, align: 'center' },
      { text: 'Tipo de pago', value: 'pago_cuotas', sortable: false, align: 'center' },
      { text: 'Estado pago', value: 'estado_pago', sortable: false, align: 'center' },
      { text: 'Apps activas', value: 'apps_activas', sortable: false, align: 'center' },
      { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
    ],
    matriculaPaymentTypes: [
      {text: 'Todos', value: 'Todos'},
      {text: 'En cuotas', value: 'En cuotas'},
      {text: 'Al contado', value: 'Al contado'}
    ],
    estadoPagoItems: [
      { text: 'Todos', value: '' },
      { text: 'Pagado', value: 'pagado' },
      { text: 'Pendiente', value: 'pendiente' }
    ],
    timeout: null,
    filters: {
      startDate: '',
      endDate: '',
      page: 1,
      search: '',
      tipoPago: 'Todos',
      seccion: null,
      estadoPago: '',
      beneficio: ''        
    },
    userSelected: null,
    matriculaSelected: null,
    beneficioItems: [
        { text: 'Todos',          value: '' },         // sin filtro
        { text: 'Con beneficio',  value: 'CON' },      // con_beneficio=1
        { text: 'Sin beneficio',  value: 'SIN' },      // beneficio_tipo=SIN (caso especial del backend)
        { text: 'Becado',         value: 'BECADO' },   // beneficio_tipo=BECADO
        { text: 'Descuento',      value: 'DESCUENTO' },// beneficio_tipo=DESCUENTO
        { text: 'Promoción',      value: 'PROMOCION' } // beneficio_tipo=PROMOCION
      ],
  }),
  watch: {
    async searchGlobal () {
      this.fetchData()
    },
    filters: {
      deep: true,
      async handler () {
        await this.fetchData()
      }
    },
    seccionesStore (val) { if (Array.isArray(val) && val.length) this.secciones = val },
  },
  computed: {
    ...mapState({
      searchGlobal: (s) => s.searchGlobal,
      seccionesStore: (s) => s.secciones || [],
    }),
    showMakePremiumModal: {
      get () {
        return !!this.userSelected
      },
      set (val) {
        if (!val) {
          this.userSelected = null
        }
        return val
      }
    },
    showPaymentAlertModal: {
      get () {
        return !!this.matriculaSelected
      },
      set (val) {
        if (!val) {
          this.matriculaSelected = null
        }
        return val
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SEARCH']),
    async fetchMatriculas() {
      const q = this.$route.query
        let url = `api/admin/matriculas/matriculas/?page_size=${this.pageSize}`
        url += `&page=${q.page || 1}`
        url += `&fecha_inicio=${q.fecha_inicio || ''}`
        url += `&fecha_fin=${q.fecha_fin || ''}`
        url += `&search=${q.search || ''}`
        url += `&tipo_pago=${q.tipo_pago || ''}`
        url += `&seccion=${q.seccion || ''}`
        url += `&estado_pago=${q.estado_pago || ''}`
        if (q.beneficio_tipo)  url += `&beneficio_tipo=${q.beneficio_tipo}`
        if (q.con_beneficio)   url += `&con_beneficio=${q.con_beneficio}`
      const matriculasResponse = await this.$http.get(url)
      this.next = matriculasResponse.data.next
      this.matriculas = matriculasResponse.data.results
      this.totalPages = Math.ceil(matriculasResponse.data.count / this.pageSize)
    },
    async fetchSecciones () {               
      const { data } = await this.$http.get('api/matriculas/secciones/')
      this.secciones = data
    },

    sendStartDate (item) {
      this.filters.page = 1
      this.filters.startDate = item
    },
    sendEndDate (item) {
      this.filters.page = 1
      this.filters.endDate = item
    },
    async fetchData () {
      clearTimeout(this.timeout)
      this.timeout = null
      this.timeout = setTimeout(async () => {
        const benefit = this.benefitQueryParams()
        await this.$router.replace(
          {
            path: this.$route.path,
            query: {
              fecha_inicio: this.filters.startDate,
              fecha_fin: this.filters.endDate,
              page: this.filters.page,
              search: this.searchGlobal,
              tipo_pago: this.filters.tipoPago,
              seccion: this.filters.seccion || '',
              estado_pago: this.filters.estadoPago || '',
              ...(benefit.beneficio_tipo ? { beneficio_tipo: benefit.beneficio_tipo } : {}),
              ...(benefit.con_beneficio ? { con_beneficio: benefit.con_beneficio } : {}),
            },
            scrollBehavior: {top: 0}
          },
        )
        await this.fetchMatriculas()
      }, 600)
    },
    setInitialQueryParams () {
      const q = this.$route.query || {}
       let beneficio = ''
        if ((q.con_beneficio || '') === '1') {
          beneficio = 'CON'
        } else if ((q.beneficio_tipo || '') === 'SIN') {
          beneficio = 'SIN'
        } else if (['BECADO', 'DESCUENTO', 'PROMOCION'].includes(q.beneficio_tipo)) {
          beneficio = q.beneficio_tipo
        }
      this.filters = {
        startDate: q.fecha_inicio,
        endDate: q.fecha_fin,
        page: Number(q.page || 1),
        search    : q.search || '',
        tipoPago  : q.tipo_pago || 'Todos',
        seccion   : q.seccion || null,
        estadoPago: q.estado_pago || '',
        beneficio 
      }
    },
    async setPremiumUser (user) {
      this.userSelected = user
    },
    async setMatricula (matricula) {
      this.matriculaSelected = matricula
    },
    async removePremium (userId, apps_names) {
      const confirm = await this.$root.$confirm({
        title: 'Mensaje de confirmación',
        message: '¿Estás seguro que deseas quitar la membresía a este usuario?',
        acceptText: 'Aceptar',
        cancelText: 'Cancelar'
      })
      if (!confirm) return

      try {
        this.loading = true
        const payload = { apps_names }
        await this.$http.post(`api/admin/matriculas/users/${userId}/delete_premium_in_apps/`, payload)

        await this.$root.$confirm({
          title: 'Mensaje',
          message: 'Se ha quitado la membresía a este usuario.',
          acceptText: 'Aceptar',
        })
        await this.fetchMatriculas()
        this.loading = false
      } catch (e) {
        this.loading = false
        await this.$root.$confirm({
          title: '!Oops!',
          message: 'Ha ocurrido un error. Inténtelo de nuevo en unos minutos.',
          acceptText: 'Ok',
        })
      }
    },
    onLocalSearchInput () {
      this.SET_SEARCH(this.searchLocal)
    },
    isPagado (item) {
  return Number(item.monto_pagado || 0) >= Number(item.monto_total || 0)
    },
    pendiente (item) {
      const rest = Number(item.monto_total || 0) - Number(item.monto_pagado || 0)
      return rest.toFixed(2)
    },
    benefitQueryParams () {
      const v = this.filters.beneficio || ''
      switch (v) {
        case 'CON':
          return { beneficio_tipo: '', con_beneficio: '1' }
        case 'SIN':
          return { beneficio_tipo: 'SIN', con_beneficio: '' }
        case 'BECADO':
        case 'DESCUENTO':
        case 'PROMOCION':
          return { beneficio_tipo: v, con_beneficio: '' }
        default: 
          return { beneficio_tipo: '', con_beneficio: '' }
        }
    },
  },
  async mounted() {
    if (this.$route.query.search) {
      await this.SET_SEARCH(this.$route.query.search)
    }    
    this.searchLocal = this.searchGlobal || ''
    if (this.seccionesStore?.length) {
      this.secciones = this.seccionesStore
    } else {
      await this.fetchSecciones()
    }
    this.setInitialQueryParams()
    await this.fetchMatriculas()
  }
};
</script>

<style lang="scss" scoped>
.enrollment_date {
  color: #1E88E5;
  font-size: 12px;
}

.app-chip {
  font-size: 10px;
  color: #FFF;
  background-color: rgba(0,0,0,.54);
  border-radius: 5px;
  padding: 5px;
}

.actions-btn {
  text-transform: none;
  letter-spacing: 0;
  width: 112px;
  min-width: 112px;

  &--secondary {
    background: rgba(0,0,0,.54) !important;
    color: white;
  }

  &--success {
    background: #4CAF50 !important;
    color: white;
  }
}
</style>
